module.exports = __webpack_public_path__ + "static/media/truck9b.ec11b3ea.svg";